export default function fetch (...args) {
  if (window.fetch) return window.fetch(...args)
  return import(/* webpackChunkName: 'unfetch' */ 'unfetch').then(unfetch =>
    unfetch.default(...args)
  )
}



// WEBPACK FOOTER //
// ./src/js/fetch.js